module.exports = __webpack_public_path__ + "img/JT_icons01_64px_More.8e0611fb.svg";